/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 09:38
 * Desc: 云店设置-收款配置
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService';

@Component
export default class PaymentConfig extends Vue {
  /* 数据 */

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  // 表单验证条件
  /**
   * 表单验证条件
   * @type {ItemObject}
   */
  public ruleArr: ItemObject = {
    wxMchId: [{ required: true, message: '请输入商户号' }],
    wxPayKey: [{ required: true, message: '请输入商户密钥' }],
    wxCertPath: [{ required: true, message: '请选择相关文件' }],
  };

  /**
   * 商户号
   * @type {string}
   */
  public mchId = '';

  /**
   * 集团的商户号列表
   * @type {any[]}
   */
  public MchIdList: Array<string> = [];

  /**
   * 商户号表单
   * @type {Array<ItemObject>}
   */
  public formMchInfo: { sgId?: number; wxPayKey?: string; wxMchId?: string; file?: any } = {
    sgId: 0,
    wxPayKey: '', // Api密钥
    file: null,
    wxMchId: '',
  };

  /**
   * 是否可配置商户号
   * @type {boolean}
   */
  public isCanConfig = false;

  /**
   * 文件名
   * @type {string}
   */
  public certName = '';

  /* 方法 */

  /**
   * 选择商户号
   * @param value
   * @return null
   */
  public onSelectMchId(value): void {
    this.mchId = value;
  }

  /**
   * 获取集团商户号列表
   * @return null
   */
  public getSiteList(): void {
    IPSService.GroupMchIdList().then((res: ItemObject) => {
      this.MchIdList = res.list;
      this.getSiteInfo(); // 获取网点组的商户号
    });
  }

  /**
   * 获取网点组的商户号
   * @return null
   */
  public getSiteInfo(): void {
    const queryParams = {
      sgId: Number.parseInt(this.$route.params.id),
    };
    IPSService.GroupMchIdInfo({ queryParams }).then((res: ItemObject) => {
      this.mchId = res.wxMchId;
    });
  }

  /**
   * 新增收款配置
   * @return null
   */
  public onAddDataConfig(): void {
    this.isCanConfig = true;
  }

  /**
   * 保存收款配置
   * @return null
   */
  public onSavePaymentConfig(): void {
    const postParams = {
      sgId: Number.parseInt(this.$route.params.id),
      wxMchId: this.mchId, // 商户号
    };
    IPSService.GroupMchIdSave({ postParams }).then((res: any) => {
      if (res && res.result) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /**
   * 文件上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  beforeFileUpload(file) {
    if (file.name.split('.')[1] != 'pfx') {
      this.$message.error('上传文件只支持 pfx 格式!');
    } else {
      this.certName = file.name;
      this.formMchInfo.file = file;
    }
    return false;
  }

  /**
   * 关闭新增商户号弹窗
   * @return null
   */
  public onAddPopHide(): void {
    this.isCanConfig = false;
  }

  /**
   * 保存新增的收款配置
   * @return null
   */
  public onSaveNewPaymentConfig(): void {
    const formData = new FormData();
    formData.append('sgId', Number.parseInt(this.$route.params.id).toString());
    formData.append('wxPayKey', this.formMchInfo.wxPayKey);
    formData.append('file', this.formMchInfo.file);
    formData.append('wxMchId', this.formMchInfo.wxMchId);
    (this.$refs.basic as ElForm).validate((valid) => {
      if (valid) {
        IPSService.saveGroupMchId({ formData })
          .then((res) => {
            if (res.data && res.data.content && res.data.content.result) {
              this.$message.success('保存成功');
              (this.$refs.basic as ElForm).resetFields();
              this.getSiteList();
              this.onAddPopHide();
            } else {
              this.$message.error('保存失败');
            }
          })
          .catch(() => {
            this.$message.error('保存失败,请检查小程序配置');
          });
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getSiteList(); // 获取集团商户号列表
  }
}
